/* ============================================================
   Kuhle Eifel – Animated Icons System
   SVG-Inlining · Hover-Farbe · Popup · Per-Word-Fonts
   ============================================================ */
(function () {
  'use strict';

  /* ── SVG: per Fetch inlinen ────────────────────────────── */
  function inlineSVG(imgEl, callback) {
    /* Shopify liefert SVG-URLs mit ?v=... oder ?width=... –
       getAttribute('src') gibt die sauberste URL zurück.      */
    var src = imgEl.getAttribute('src') || imgEl.src || '';
    if (!src) { callback(null); return; }

    fetch(src, { mode: 'cors' })
      .then(function (res) {
        if (!res.ok) throw new Error('fetch failed');
        return res.text();
      })
      .then(function (svgText) {
        var parser = new DOMParser();
        var doc    = parser.parseFromString(svgText, 'image/svg+xml');
        var svgEl  = doc.querySelector('svg');
        if (!svgEl) { callback(null); return; }

        /* Dimensionen aus dem Container übernehmen, kein
           hardcoded width/height-Attribut übrig lassen      */
        svgEl.style.width   = '100%';
        svgEl.style.height  = '100%';
        svgEl.style.display = 'block';
        svgEl.removeAttribute('width');
        svgEl.removeAttribute('height');

        imgEl.parentNode.replaceChild(svgEl, imgEl);
        callback(svgEl);
      })
      .catch(function () {
        /* CORS oder Netzwerk-Fehler → kein Inlining,
           Fallback bleibt <img>                              */
        callback(null);
      });
  }

  /* ── Hover-Farbe: SVG-Inlining erfolgreich ─────────────── */
  function applyHoverColorSVG(wrapper, svgEl, color) {
    /* Eindeutige ID für diesen SVG → CSS-Selektor wird damit
       auf exakt dieses Element beschränkt, kein Page-Leakage  */
    if (!svgEl.id) {
      svgEl.id = 'ke-svg-' + Math.random().toString(36).slice(2, 9);
    }
    var id = svgEl.id;
    var sel = ['path','circle','rect','ellipse','polygon','polyline','line','use']
                .map(function (t) { return '#' + id + ' ' + t; })
                .join(', ');

    wrapper.addEventListener('mouseenter', function () {
      /* Strategie 1: explizite fill/stroke-Attribute */
      svgEl.querySelectorAll('[fill]:not([fill="none"]):not([fill="transparent"])').forEach(function (el) {
        el.dataset.keFill = el.getAttribute('fill');
        el.setAttribute('fill', color);
      });
      svgEl.querySelectorAll('[stroke]:not([stroke="none"]):not([stroke="transparent"])').forEach(function (el) {
        el.dataset.keStroke = el.getAttribute('stroke');
        el.setAttribute('stroke', color);
      });

      /* Strategie 2: scoped <style>-Injektion (Selektor mit #id
         → wirkt NUR auf diesen SVG, kein Leakage auf andere
         Icons oder Section-Hintergrund)                       */
      var s = document.createElement('style');
      s.className = 'ke-color-override';
      s.textContent = sel + ' { fill: ' + color + ' !important; stroke: none !important; }';
      svgEl.appendChild(s);
    });

    wrapper.addEventListener('mouseleave', function () {
      /* Attribute zurücksetzen */
      svgEl.querySelectorAll('[data-ke-fill]').forEach(function (el) {
        el.setAttribute('fill', el.dataset.keFill);
        delete el.dataset.keFill;
      });
      svgEl.querySelectorAll('[data-ke-stroke]').forEach(function (el) {
        el.setAttribute('stroke', el.dataset.keStroke);
        delete el.dataset.keStroke;
      });

      /* Scoped Override-Style entfernen */
      var s = svgEl.querySelector('style.ke-color-override');
      if (s) s.remove();
    });
  }

  /* ── Hover-Farbe: Fallback für <img> (kein Inlining) ───── */
  function applyHoverColorImg(wrapper, imgEl, color) {
    /* Berechnet CSS-Filter, der die Farbe annähert.
       Funktioniert zuverlässig für helle Ursprungsicons.    */
    var f = hexToFilter(color);

    wrapper.addEventListener('mouseenter', function () {
      imgEl.style.filter = f;
    });
    wrapper.addEventListener('mouseleave', function () {
      imgEl.style.filter = '';
    });
  }

  /* ── Hex → CSS-filter Konverter ──────────────────────────
     Basiert auf: https://codepen.io/sosuke/pen/Pjoqqp
     Löst numerisch, um jeden Hex-Farbwert anzunähern.      */
  function hexToFilter(hex) {
    hex = hex.replace('#', '');
    if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    var r = parseInt(hex.slice(0,2),16)/255;
    var g = parseInt(hex.slice(2,4),16)/255;
    var b = parseInt(hex.slice(4,6),16)/255;

    /* Greift auf einen einfachen Hue-Rotate-Ansatz zurück,
       der für satte Farben sehr gut funktioniert           */
    var max = Math.max(r,g,b), min = Math.min(r,g,b);
    var h = 0, s = 0, l = (max+min)/2;
    if (max !== min) {
      var d = max - min;
      s = l > 0.5 ? d/(2-max-min) : d/(max+min);
      switch(max) {
        case r: h = ((g-b)/d + (g < b ? 6 : 0))/6; break;
        case g: h = ((b-r)/d + 2)/6; break;
        case b: h = ((r-g)/d + 4)/6; break;
      }
    }
    h = Math.round(h*360);
    s = Math.round(s*100);
    l = Math.round(l*100);

    /* Umweg: erst auf schwarz reduzieren, dann zur Zielfarbe */
    return (
      'brightness(0) saturate(100%) ' +
      'invert(1) ' +
      'sepia(1) ' +
      'saturate(' + Math.round(s * 3) + '%) ' +
      'hue-rotate(' + h + 'deg) ' +
      'brightness(' + Math.round(l * 1.5) + '%)'
    );
  }

  /* ── Hilfsfunktionen für Per-Word-Fonts ───────────────── */
  function escRx(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function buildSizeMap(raw) {
    var map = {};
    if (!raw) return map;
    raw.split(',').forEach(function (entry) {
      entry = entry.trim();
      if (!entry) return;
      var idx = entry.indexOf(':');
      if (idx < 1) return;
      var word = entry.slice(0, idx).trim().toLowerCase();
      var size = entry.slice(idx + 1).trim();
      if (word && size) map[word] = size;
    });
    return map;
  }

  function wrapWords(container, raw, cssClass, sizeMap) {
    if (!raw || !raw.trim()) return;
    var words = raw.split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    if (!words.length) return;
    var pattern = new RegExp('\\b(' + words.map(escRx).join('|') + ')\\b', 'gi');

    function walk(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        pattern.lastIndex = 0;
        if (!pattern.test(node.textContent)) return;
        var frag = document.createDocumentFragment();
        var text = node.textContent;
        var last = 0;
        pattern.lastIndex = 0;
        var m;
        while ((m = pattern.exec(text)) !== null) {
          if (m.index > last)
            frag.appendChild(document.createTextNode(text.slice(last, m.index)));
          var span = document.createElement('span');
          span.className = cssClass;
          var key = m[0].toLowerCase();
          if (sizeMap[key]) span.style.fontSize = sizeMap[key];
          span.textContent = m[0];
          frag.appendChild(span);
          last = m.index + m[0].length;
        }
        if (last < text.length)
          frag.appendChild(document.createTextNode(text.slice(last)));
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.classList.contains('font-handwriting') ||
            node.classList.contains('font-bold') ||
            node.classList.contains('font-semibold')) return;
        Array.from(node.childNodes).forEach(walk);
      }
    }
    Array.from(container.childNodes).forEach(walk);
  }

  function applyPopupFonts(popupTextEl, dataset) {
    var sizeMap = buildSizeMap(dataset.popupWordSizes);
    wrapWords(popupTextEl, dataset.popupHwWords,  'font-handwriting', sizeMap);
    wrapWords(popupTextEl, dataset.popupBoldWords, 'font-bold',        sizeMap);
    wrapWords(popupTextEl, dataset.popupSbWords,   'font-semibold',    sizeMap);
  }

  /* ── Popup: Mobile-Toggle + Click-Outside ─────────────── */
  function initPopup(itemEl) {
    var popup = itemEl.querySelector('.ke-popup');
    if (!popup) return;

    var bg = popup.style.backgroundColor;
    if (bg) popup.style.setProperty('--ke-popup-bg', bg);

    itemEl.addEventListener('click', function (e) {
      if (!window.matchMedia('(hover: hover)').matches) {
        e.stopPropagation();
        var active = itemEl.classList.contains('ke-popup-active');
        document.querySelectorAll('.ke-icon-item.ke-popup-active').forEach(function (el) {
          el.classList.remove('ke-popup-active');
        });
        if (!active) itemEl.classList.add('ke-popup-active');
      }
    });
  }

  var globalListenerAdded = false;
  function ensureGlobalListener() {
    if (globalListenerAdded) return;
    globalListenerAdded = true;
    document.addEventListener('click', function () {
      document.querySelectorAll('.ke-icon-item.ke-popup-active').forEach(function (el) {
        el.classList.remove('ke-popup-active');
      });
    });
  }

  /* ── Ein Icon-Item initialisieren ─────────────────────── */
  function initIconItem(itemEl) {
    if (itemEl.dataset.keInit === '1') return;
    itemEl.dataset.keInit = '1';

    var wrapper  = itemEl.querySelector('.ke-icon-wrapper');
    if (!wrapper) return;

    var hcEnable = itemEl.dataset.hoverColorEnable === 'true';
    var hcColor  = (itemEl.dataset.hoverColor || '').trim();
    var hasPopup = itemEl.dataset.popupEnable === 'true';

    /* SVG inlinen */
    var imgEl = wrapper.querySelector('img');
    if (imgEl) {
      var src = imgEl.getAttribute('src') || imgEl.src || '';
      var isSVG = src.toLowerCase().indexOf('.svg') !== -1;

      if (isSVG) {
        inlineSVG(imgEl, function (svgEl) {
          if (hcEnable && hcColor) {
            if (svgEl) {
              /* Inlining erfolgreich → direkte SVG-Manipulation */
              applyHoverColorSVG(wrapper, svgEl, hcColor);
            } else {
              /* Inlining gescheitert (CORS etc.) → Filter-Fallback */
              var img = wrapper.querySelector('img');
              if (img) applyHoverColorImg(wrapper, img, hcColor);
            }
          }
        });
      } else {
        /* Kein SVG → Filter-Fallback sofort */
        if (hcEnable && hcColor) applyHoverColorImg(wrapper, imgEl, hcColor);
      }
    }

    /* Popup */
    if (hasPopup) {
      var textEl = itemEl.querySelector('.ke-popup__text');
      if (textEl) applyPopupFonts(textEl, itemEl.dataset);
      initPopup(itemEl);
      ensureGlobalListener();
    }
  }

  /* ── Heading Per-Word-Fonts ────────────────────────────── */
  function initHeadingFonts(pfEl) {
    if (pfEl.dataset.keHeadingInit === '1') return;
    pfEl.dataset.keHeadingInit = '1';

    var headingEl = pfEl.querySelector('.product-featured__heading');
    if (!headingEl) return;

    var ds = pfEl.dataset;
    var hw   = (ds.headingHwWords || '').trim();
    var bold = (ds.headingBoldWords || '').trim();
    var sb   = (ds.headingSemiboldWords || '').trim();
    var sizes = (ds.headingWordSizes || '').trim();

    if (!hw && !bold && !sb) return;

    var sizeMap = buildSizeMap(sizes);
    wrapWords(headingEl, hw,   'font-handwriting', sizeMap);
    wrapWords(headingEl, bold, 'font-bold',        sizeMap);
    wrapWords(headingEl, sb,   'font-semibold',    sizeMap);
  }

  /* ── Alle Icons initialisieren ────────────────────────── */
  function initAll() {
    document.querySelectorAll('.ke-icon-item:not([data-ke-init="1"])').forEach(initIconItem);
    document.querySelectorAll('.product-featured:not([data-ke-heading-init="1"])').forEach(initHeadingFonts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
